module.exports = __webpack_public_path__ + "img/Extracting.631ab645.gif";